import type { AnalyticsData } from "../analyticsData";
import { combineAnalyticsData } from "../analyticsData";
import { getAndConvertAnalyticsNavigationProperties } from "../properties/event";

export function getAnalyticsSettingChangedEvent(settingData: AnalyticsData) {
    const map = combineAnalyticsData(getAndConvertAnalyticsNavigationProperties(), settingData);
    return map;
}
